/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Switch_To_Website_TabInputs */

const en_common_switch_to_website_tab = /** @type {(inputs: Common_Switch_To_Website_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to a website tab to disable it`)
};

const es_common_switch_to_website_tab = /** @type {(inputs: Common_Switch_To_Website_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia a una pestaña web para deshabilitarla`)
};

/**
* | output |
* | --- |
* | "Switch to a website tab to disable it" |
*
* @param {Common_Switch_To_Website_TabInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_switch_to_website_tab = /** @type {((inputs?: Common_Switch_To_Website_TabInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Switch_To_Website_TabInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_switch_to_website_tab(inputs)
	return en_common_switch_to_website_tab(inputs)
});